import partner from './engine'
import logSettings from './config/logging'
import { getRemoteUrls } from '../utils/browserStructure'

import { runRegistrationShadowPostmate } from './remote'
import { runPartnerCrawler } from '../crawler/partnerCrawler'
import { getApplicationRunMode, APPLICATION_MODES, runModeAndConfirm, mockRegilyJSApi } from './appModeHelpers'

// normal registration flow in partner site
export const standardModeHandler = () => {
  partner.config = {
    triggers: {
      click: [
        '#signup',
        '[data-regily-trigger="click"]'
      ]
    },
    callbacks: {
      update (data, dataDiff) {
        callbackInfoLogging('Updated data', data)
        callbackInfoLogging('Updated data diff', dataDiff)

        if (typeof window['regilyUpdateCallback'] === 'function') {
          return window['regilyUpdateCallback'](data, dataDiff)
        }
      },

      done (data) {
        callbackInfoLogging('Received data', data)

        if (typeof window['regilyCallback'] === 'function') {
          return window['regilyCallback'](data)
        }

        if (typeof window['regilyDoneCallback'] === 'function') {
          return window['regilyDoneCallback'](data)
        }
      },

      event (data) {
        if (typeof window['regilyEventCallback'] === 'function') {
          return window['regilyEventCallback'](data)
        }
      }
    },

    requestCallback (url, data) {
      return fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        },
        body: JSON.stringify(data)
      })
    }
  }

  partner.start()
}

function callbackInfoLogging(...args){
  if(logSettings.enableCallbackLogging) {
    console.info(...args)
  }
}

// in case script is loaded in affiliate site and window.regilyRemote is declared
export const remoteModeHandler = () => {
  const { registrationUrl, redirectUrl } = getRemoteUrls()

  partner.config = {
    remote: {
      registrationUrl,
      redirectUrl
    }
  }
  partner.start()
}

// in case script is loaded in partner site with crawler mode
export const crawlerModeHandler = () => runModeAndConfirm(runPartnerCrawler)

// in case script is loaded in partner site with proxy mode
export const proxyModeHandler = async () => runModeAndConfirm(runRegistrationShadowPostmate)

const applicationModeRunners = {
  [APPLICATION_MODES.STANDARD]: standardModeHandler,
  [APPLICATION_MODES.REMOTE]: remoteModeHandler,
  [APPLICATION_MODES.PROXY]: proxyModeHandler,
  [APPLICATION_MODES.CRAWLER]: crawlerModeHandler
}

export const init = async () => {
  mockRegilyJSApi()

  const mode = await getApplicationRunMode()
  const applicationHandler = applicationModeRunners[mode] || standardModeHandler

  console.log('Regily init', mode)
  applicationHandler()
}

init()



// WEBPACK FOOTER //
// ./src/partners/partner-client-template.js